import React from 'react'
import { replace, isNull } from 'lodash'
import styled from 'styled-components'
import theme from '../../../../theme/theme'
import convertHexToRGBA from '../../../../helpers/HexToRgba'

//////STYLED//////
const Wrapper = styled.div`
	display: flex;
	flex: 4;
	column-gap: 1rem;
	font-size: 14px;
`
const NewPriceBlock = styled.div`
	text-align: left;
	flex: 2;
`
const NewPrice = styled.span`
	background-color: ${convertHexToRGBA(theme.colors.primary, 0.2)};
	color: ${theme.colors.primary};
	width: fit-content;
	padding: 7px 10px;
	border-radius: 15px;
	margin: 0 auto;
	font-weight: bold;
	line-height: 25px;
`
const OldPriceBlock = styled.div`
	text-align: left;
	flex: 2;
`
const OldPrice = styled.span`
	color: ${theme.text.colors.primary};
	text-decoration: line-through;
	width: fit-content;
	border-radius: 15px;
	margin: 0 auto;
	line-height: 25px;
`
const EmptyBlock = styled.div`
	flex: 2;
`
//////STYLED//////

const ItemCatalogDetailPrice = ({ target, ItemDetail }) => {
	///////////////////////////////// RENDER ///////////////////////////////////////

	return (
		<Wrapper>
			{target == 'withPromo' ? (
				<NewPriceBlock>
					<NewPrice>
						{!isNull(ItemDetail?.promoPrice) ? replace(parseFloat(ItemDetail?.promoPrice).toFixed(2), '.', ',') : '0,00'}
						{ItemDetail?.currency?.symbol}
					</NewPrice>
				</NewPriceBlock>
			) : (
				<NewPriceBlock>
					<NewPrice>
						{!isNull(ItemDetail?.standardPrice) ? replace(parseFloat(ItemDetail?.standardPrice).toFixed(2), '.', ',') : '0,00'}
						{ItemDetail?.currency?.symbol}
					</NewPrice>
				</NewPriceBlock>
			)}
			{target == 'withPromo' ? (
				<OldPriceBlock>
					<OldPrice>
						{!isNull(ItemDetail?.standardPrice) ? replace(parseFloat(ItemDetail?.standardPrice).toFixed(2), '.', ',') : '0,00'}
						{ItemDetail?.currency?.symbol}
					</OldPrice>
				</OldPriceBlock>
			) : (
				<EmptyBlock></EmptyBlock>
			)}
		</Wrapper>
	)
}

export default ItemCatalogDetailPrice
